let avatars_temp = []
avatars_temp[0] = require('../assets/images/avatars/0.png');
avatars_temp[1] = require('../assets/images/avatars/1.png');


const avatars = avatars_temp
export {
	avatars
}